module.exports = __webpack_public_path__ + "img/schedule2.7706eaf9.png";